import NotificationsContainer from './NotificationsContainer';

export { NotificationsContainer };

export default NotificationsContainer;